module.exports = __webpack_public_path__ + "img/k.78136a21.jpg";